import { Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";

const MobileTopBar = ({
  logo,
  cartCount,
  isCartLoading,
  shouldShowCollections,
  menuStructure,
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  appUser,
  searchTerm,
  setSearchTerm,
  handleSearchSubmit,
  handleSearchKeyDown,
  handleVoiceInput,
  isListening,
  isVoiceSupported,
  searchPlaceholder,
}) => (
  <div className="bg-white border-bottom-1 surface-border px-3">
    <div className="flex align-items-center justify-content-between" style={{ height: 56 }}>
      <Link to="/" aria-label="Ir al inicio">
        <img src={logo.src} alt={logo.alt} style={{ height: 36, maxWidth: 140, objectFit: "contain" }} />
      </Link>
      <div className="flex align-items-center gap-2">
        {appUser ? (
          <Link to="/carro" className="relative flex align-items-center p-2 text-gray-700 no-underline" aria-label="Ir al carro">
            <i className="pi pi-shopping-cart text-lg"></i>
            {isCartLoading ? (
              <span className="landing-cart-count is-loading">
                <i className="pi pi-spin pi-spinner text-xs"></i>
              </span>
            ) : (
              <Badge value={cartCount} />
            )}
          </Link>
        ) : null}
        {shouldShowCollections ? (
          <Button
            icon={isMobileMenuOpen ? "pi pi-times" : "pi pi-bars"}
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            aria-label={isMobileMenuOpen ? "Cerrar menú de colecciones" : "Abrir menú de colecciones"}
            aria-expanded={isMobileMenuOpen}
            text
            rounded
            disabled={!menuStructure.length}
            className="text-gray-700"
            style={{ width: 40, height: 40 }}
          />
        ) : null}
      </div>
    </div>
    <div className="pt-2 pb-3">
      <div className="flex align-items-center bg-gray-100 border-round-sm border-1 surface-border px-3">
        <Button
          type="button"
          text
          className="text-gray-500"
          aria-label="Buscar productos"
          onClick={handleSearchSubmit}
          icon="pi pi-search"
        />
        <InputText
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleSearchKeyDown}
          placeholder={searchPlaceholder || "¿Qué estás buscando?"}
          aria-label="Buscar productos"
          className="flex-1 bg-transparent border-none outline-none text-sm text-gray-700"
        />
        <Button
          type="button"
          text
          className={isListening ? "text-red-500" : "text-gray-500"}
          aria-label={isListening ? "Detener dictado por voz" : "Iniciar dictado por voz"}
          onClick={handleVoiceInput}
          aria-disabled={!isVoiceSupported}
          icon={isListening ? "pi pi-stop-circle" : "pi pi-microphone"}
        />
      </div>
    </div>
  </div>
);

export default MobileTopBar;
